<template>
  <div
    class="app-main-inner sop-message-setting-form"
    style="display: flex;flex-direction: column;"
  >
    <div class="app-main-inner-row" style="margin-left: -32px !important;">
      <!--sop推送日志-->
      <el-card class="box-card" style="flex-grow: 1">
        <div class="app-main-inner-row">
          <div>
            <el-button v-if="!readOnly" type="primary" @click="addSop">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button v-if="!readOnly" type="danger" @click="delSop">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
        </div>
        <div class="app-main-inner-row">
          <cargo-ag-grid
            :show-side-bar="false"
            :column-defs="sopGrid.columnDefs"
            :row-data="sopGrid.rowData"
            :grid-options="sopGrid.gridOptions"
            style="width: 100%;height:200px;"
            @gridReady="onSopReady"
          />
        </div>
        <el-form v-show="sopForm.hasOwnProperty('uuid')" ref="trackingDetailForm" :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.PushTarget')">
            <el-select v-model="sopForm.pushObject" style="width:300px;" @change="refreshGrid">
              <el-option v-for="item in pushObjects" :key="item.name" :label="item.chineseName" :value="item.name" />
            </el-select>
            <template v-if="multipleTrigger">
              <el-checkbox v-model="sopForm.valueChangePushMsg" style="padding-left: 10px" :label="$t('SystemMaintenance.TriggerTypeChangePushMsg')" />
              <el-tooltip :content="$t('SystemMaintenance.AgainPushTitleDisplay')" placement="right">
                <i class="el-icon-warning" style="color: #E6A23C;font-size: 13px;padding: 0 5px;" />
              </el-tooltip>
            </template>
            <template v-if="!isEnterpriseWechat && sopForm.pushObject === 'customer'">
              <el-checkbox v-model="sopForm.checkBase" style="padding-left: 10px" :label="$t('SystemMaintenance.CheckBaseLabel')" />
            </template>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.PushChannel')">
            <el-select v-model="sopForm.pushChannel" style="width:300px;" @change="refreshGrid">
              <el-option v-for="item in pushChannels" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
            <el-checkbox v-if="!isEnterpriseWechat && sopForm.pushObject !== 'DesignatedPostsAndPersonnel'" v-model="sopForm.sendAlone" style="padding-left: 10px" :label="$t('CargoMsg.Cargo_SendToEachRecipientSeparately')" />
            <el-checkbox v-show="!isEnterpriseWechat && showSyncSendCCAddress" v-model="sopForm.syncSendCCAddress" style="padding-left: 10px" :label="$t('CargoMsg.Cargo_SyncSendCCAddress')" />
          </el-form-item>
          <el-form-item v-show="!isEnterpriseWechat" :label="$t('SystemMaintenance.MailServer')">
            <div style="display: flex">
              <el-select :value="sopForm.mailServerType||''" clearable style="width:300px;" @input="onMailServerTypeInput">
                <el-option :label="$t('SystemMaintenance.SystemEmail')" :value="1" />
                <el-option :label="$t('SystemMaintenance.CompanyEmail')" :value="2" />
                <el-option :label="$t('SystemMaintenance.PersonalEmail')" :value="3" />
              </el-select>
              <div v-show="sopForm.mailServerType===2||sopForm.mailServerType===3" style="margin-left: 10px;">
                <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;line-height: 18px;" />
                <span style="line-height: 18px;">
                  {{ sopForm.mailServerType === 2 ? $t('SystemMaintenance.PushConfigServiceCompanyEmail') : $t('SystemMaintenance.PushConfigServicePersonalEmail') }}
                </span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="!isEnterpriseWechat && sopForm.mailServerType===3" :label="$t('SystemMaintenance.SelectSendEmail')">
            <div style="display: flex">
              <el-radio-group v-model="sopForm.sendEmail" @change="onSendEmailChange">
                <el-radio :label="1" style="margin-right: 10px;line-height: 29px;">{{ $t('CargoMsg.Cargo_Post') }}</el-radio>
                <el-radio :label="2" style="margin-right: 10px;line-height: 29px;">{{ $t('SystemMaintenance.Assigner') }}</el-radio>
              </el-radio-group>
              <el-select v-if="sopForm.sendEmail===1" v-model="sopForm.position" style="width:162px;">
                <el-option :label="$t('CargoMsg.Cargo_Sales')" value="sales" />
                <el-option :label="$t('Message.Operation')" value="op" />
                <el-option :label="$t('CargoMsg.Cargo_CustomerService')" value="csr" />
                <el-option :label="$t('CargoMsg.Cargo_CustomerServiceOverSea')" value="overseaOp" />
                <el-option :label="$t('CargoMsg.Cargo_Documents')" value="doc" />
                <el-option v-if="lob==='SE'||lob==='SI'||lob==='IE'" :label="$t('CargoMsg.Cargo_AirlinePerson')" value="seaLine" />
                <el-option v-if="lob==='AE'||lob==='AI'" :label="$t('CargoMsg.Cargo_AirlinePerson')" value="airline" />
                <el-option v-if="lob==='RE'||lob==='RI'" :label="$t('CargoMsg.Cargo_AirlinePerson')" value="railwayLine" />
                <el-option :label="$t('Clearing.CargoSales')" value="salesOfGoods" />
                <el-option :label="$t('SeaExport.FieldOperation')" value="siteOp" />
                <el-option :label="$t('CargoMsg.Cargo_userDefinedRole1')" value="userDefinedRole1" />
                <el-option :label="$t('CargoMsg.Cargo_userDefinedRole2')" value="userDefinedRole2" />
              </el-select>
              <cargo-advance-select
                v-if="sopForm.sendEmail===2"
                :disabled="readOnly"
                :select-type="selectTypeNames.basic_data_User"
                :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                :default-value="sopForm.assigner||''"
                filterable
                style="width:162px"
                @parentCallBack="p=>{sopForm.assigner=p.value||0}"
              />
            </div>
          </el-form-item>
          <template>
            <!--邮件部分star-->
            <div v-show="sopForm.pushChannel===0 || isEnterpriseWechat">
              <el-form-item v-show="!isEnterpriseWechat" :label="$t('SystemMaintenance.SubjectTemplate')">
                <el-input
                  ref="themeTemplate"
                  v-model="templateTitle2Email"
                  @focus="eFocus=constant.eFocus.emailTitle"
                  @blur="blurEvent"
                />
              </el-form-item>
              <el-form-item :label="!isEnterpriseWechat ? $t('SystemMaintenance.TextTemplate') : $t('CargoMsg.Cargo_MessageContent')" style="height: 230px;">
                <quill-editor
                  ref="emailTextQuillEditor"
                  v-model="sopForm.templateText2Email"
                  :disabled="readOnly"
                  :options="editorOption"
                  style="height: 175px;"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)"
                  @keyup.enter.native="keyUp()"
                />
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.DataItem')">
                <!--                <div v-if="lob === 'SE'">-->
                <div style="display: flex; margin-bottom: 50px;width:66%;">
                  <div ref="dataItemTabDiv" class="outside">
                    <div style="position:relative;">
                      <i v-show="readOnly" class="mask" />
                      <div class="outside-value" @click="spread">{{ showName }}</div>
                      <i class="el-icon-arrow-down icon" :class="{'rotatingShow': isShow, 'rotatingHide': !isShow, }" />
                    </div>
                    <div v-show="isShow" class="operation">
                      <div v-for="(item, index) in dataItemTabs" :key="index" class="item" :class="{'set-color': value === item.code, 'set-bgc': index === 0}" @click="selectItem(item)">
                        <span>{{ isZh ? item.chineseName : item.englishName }}</span>
                      </div>
                    </div>
                    <div v-show="isShow && dataItems" class="dataItem">
                      <span
                        v-for="(item, itemIndex) in dataItems"
                        :key="itemIndex"
                        class="item"
                        :class="{itemChoose:chooseId === itemIndex}"
                        @click.stop="onClickSopDataItemByContent(item.chineseName, itemIndex)"
                      >{{ item.chineseName }}</span>
                    </div>
                  </div>
                  <cargo-advance-select
                    :static-options="dataItems"
                    :placeholder="$t('CargoMsg.Cargo_SearchForTheDataYouWantToInsert')"
                    :cache="false"
                    style="width: 300px;"
                    filterable
                    filter-type="global"
                    clearable
                    tag-value="chineseName"
                    :default-value="dataItem"
                    @parentCallBack="changeDataItem"
                    @focus="dataItemFocusEvent"
                  />
                </div>
                <!--                </div>-->
                <!--                <el-button v-for="(item,index) in sopDataItems" v-else :key="index" type="" style="margin-left: 0px;margin-right: 10px;" @click="onClickSopDataItem(index)">{{ item }}</el-button>-->
              </el-form-item>
              <el-form-item :label="!isEnterpriseWechat ? $t('SystemMaintenance.AttachmentFileType') : $t('CargoMsg.Cargo_PushFiles')">
                <div style="display: flex">
                  <el-input v-show="readOnly" v-model="currFileTypeNames" style="width:300px;" :disabled="true" />
                  <!-- <el-dropdown v-show="!readOnly" trigger="click" placement="bottom-start">
                  <span class="el-dropdown-link">
                    <el-input v-model="currFileTypeNames" style="width:300px;" readonly />
                  </span>
                  <el-dropdown-menu slot="dropdown" class="app-main-inner-row row-grid" style="width: 350px;height: 200px;">

                    <cargo-ag-grid
                      :show-side-bar="false"
                      :grid-options="fileTreeGrid.gridOptions"
                      :column-defs="fileTreeGrid.columnDefs"
                      :row-data="[]"
                      style="width:100%;height:100%;"
                    />
                  </el-dropdown-menu>
                </el-dropdown> -->
                  <el-input v-show="!readOnly" v-model="currFileTypeNames" style="width:300px;" readonly @focus="showFileTypeDialog" />
                  <div v-show="isEnterpriseWechat" style="margin-left: 10px;">
                    <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;line-height: 18px;" />
                    <span style="line-height: 18px;"> {{ $t('CargoMsg.Cargo_PushFilesTip') }} </span>
                  </div>
                </div>
              </el-form-item>
            </div>
          </template>
          <template>
            <div v-show="sopForm.pushChannel===1">
              <!--短信部分star-->
              <el-form-item :label="$t('SystemMaintenance.TemplateSubject')">
                <el-select v-model="sopForm.templateTheme" style="width:300px;">
                  <el-option v-for="item in templateThemes" :key="item.code" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.TemplateContent')">
                <el-input
                  v-model="sopForm.templateTitle2Note"
                  disabled
                  type="textarea"
                  :rows="5"
                  @focus="eFocus=constant.eFocus.noteContent"
                />
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.TemplateExample')">
                <el-input
                  v-model="sopForm.templateText2Note"
                  type="textarea"
                  :rows="5"
                  disabled
                />
              </el-form-item>
            </div>
          </template>
        </el-form>
        <div v-show="sopForm.hasOwnProperty('uuid') && !isEnterpriseWechat" class="app-main-inner-row" style="justify-content: center;padding-top:30px;">
          <el-button type="primary" @click="showSendSopTest">{{ !isEnterpriseWechat ? $t('SystemMaintenance.SendTest') : $t('CargoMsg.Cargo_Save') }}</el-button>
        </div>
      </el-card>
    </div>
    <el-dialog
      :visible.sync="sendSopTest.visible"
      :title="$t('SystemMaintenance.SendTest')"
      width="400px"
      close-on-click-modal
    >
      <span>{{ $t('SystemMaintenance.SendTo') }}</span>
      <el-input v-model="sendSopTest.target" style="width: 200px" />
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="sendSopTestHandler">{{ $t('SystemMaintenance.Confirm') }}</el-button>
        <el-button type="primary" @click="sendSopTestCloseHandler">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="onSaveFileType"
    />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor' // 调用富文本编辑器
import 'quill/dist/quill.snow.css' // 富文本编辑器外部引用样式  三种样式三选一引入即可
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as TrackingTemplateConfigApi from '@/api/sysManage/baseConfig/businessManage'
import { getLoading } from '@/utils/utilBaseElement'
import { getTemplateTheme } from '@/api/sysManage/baseConfig/businessManage'
import ZH from '@/lang/zh'
import URL from '@/api/urlTranslator'

import { getGridSelected } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SopDataItemTabConstants from '@/class/cargo/model/parameters/SopDataItemTabConstants'
import * as SopDataItemConstants from '@/class/cargo/model/parameters/SopDataItemConstants'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'

export default {
  name: 'SopMessageSettingForm',
  components: {
    quillEditor,
    cargoAdvanceSelect,
    MxFileTypeEditor
  },
  props: {
    lob: {
      type: String,
      required: true
    },
    trackingDetail: {
      type: Object,
      default: () => {}
    },
    fileTreeMap: { // 文件类型
      type: Object,
      default: () => {}
    },
    opStatus: { type: String, default: '' }, // 操作状态：add|edit|read
    multipleTrigger: { type: Boolean, default: false }
  },
  data() {
    return {
      value: '基础数据',
      isShow: false,
      loading: false,
      dataItem: '',
      dataItemTab: 1,
      chooseId: '',
      dataItemTabs: [],
      selectTypeNames: TYPE_NAMES,
      editorOption: {
        // some quill options
        placeholder: this.$t('SystemMaintenance.PleaseEnterContent'),
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        }
      },
      stateTypes: [ // 状态类型
        { name: 'STATE_TYPE_NOT_START', value: 1, chineseName: '未开始', englishName: 'NotStart' },
        { name: 'STATE_TYPE_IN', value: 2, chineseName: '进行中', englishName: 'In' },
        { name: 'STATE_TYPE_COMPLETE', value: 3, chineseName: '已完成', englishName: 'Complete' },
        { name: 'STATE_TYPE_EXCPTION', value: 4, chineseName: '异常', englishName: 'Exception' }
      ],
      allTemplateTheme: { // 模板主题全量
        SMS_471385302: { name: 'SMS_471385302', code: 'SMS_471385302', chineseName: '订舱成功', englishName: 'Successful Booking' },
        SMS_471455277: { name: 'SMS_471455277', code: 'SMS_471455277', chineseName: '入仓通知', englishName: 'Warehouse Notice' },
        SMS_471475272: { name: 'SMS_471475272', code: 'SMS_471475272', chineseName: '报关放行', englishName: 'Customs clearance' },
        SMS_471480298: { name: 'SMS_471480298', code: 'SMS_471480298', chineseName: '开航通知', englishName: 'Navigation Notice' },
        SMS_471485278: { name: 'SMS_471485278', code: 'SMS_471485278', chineseName: '签发提单', englishName: 'issue a bill of lading' }
      },
      allPushChannel: [{ name: this.$t('constant.email'), value: 0 }, { name: this.$t('constant.note'), value: 1 }, { name: this.$t('constant.enterpriseWechat'), value: 2 }],
      allPushObject2: [ // 推送对象全量
        { name: 'customer', chineseName: '客户', englishName: 'CUSTOMER' },
        { name: 'DestinationAgent', chineseName: '目的港代理', englishName: 'Destination Agent' },
        { name: 'DesignationAgent', chineseName: '指定货代理', englishName: 'Designation Agent' },
        { name: 'PortOfLoadingAgent', chineseName: '起运港代理', englishName: 'PortOfLoading Agent' },
        { name: 'DesignatedPostsAndPersonnel', chineseName: '指定岗位和指定人员', englishName: 'Designated posts and designated personnel' },
        { name: 'Shipper', chineseName: '发货人', englishName: 'Shipper' },
        { name: 'Consignee', chineseName: '收货人', englishName: 'Consignee' },
        { name: 'Notify', chineseName: '通知人', englishName: 'Notify' }
      ],
      allPushObject: { // 推送对象全量
        CUSTOMER: { name: 'customer', chineseName: '客户', englishName: 'CUSTOMER' },
        DESTINATION_AGENT2: { name: 'DestinationAgent', chineseName: '目的港代理', englishName: 'Destination Agent' },
        DESIGNATION_AGENT2: { name: 'DesignationAgent', chineseName: '指定货代理', englishName: 'Designation Agent' },
        DESIGNATION_AGENT3: { name: 'PortOfLoadingAgent', chineseName: '起运港代理', englishName: 'PortOfLoading Agent' },
        DesignatedPostsAndPersonnel: { name: 'DesignatedPostsAndPersonnel', chineseName: '指定岗位和指定人员', englishName: 'Designated posts and designated personnel' },
        SHIPPER: { name: 'Shipper', chineseName: '发货人', englishName: 'Shipper' },
        CONSIGNEE: { name: 'Consignee', chineseName: '收货人', englishName: 'Consignee' },
        NOTIFY: { name: 'Notify', chineseName: '通知人', englishName: 'Notify' }
      },
      constant: {
        eFocus: { emailTitle: 'emailTitle', emailContent: 'emailContent', noteTitle: 'noteTitle', noteContent: 'noteContent' }
      },
      eFocus: '', // 获取焦点的元素 （email:标题、文本，msg:标题、文本）
      cursor: '',
      blurIndex: '',
      currentTriggerObj: {}, // 当前触发类型选项
      sopGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          onRowClicked: this.onSopRowClick
        },
        gridParams: {},
        gridApi: {},
        columnDefs: [
          {
            headerName: this.$t('SystemMaintenance.PushTarget'),
            width: 200,
            field: 'pushObject',
            cellRenderer: (params) => {
              const row = this.allPushObject2.find(item => {
                return item.name === params.value
              })
              return row ? row.chineseName : params.value
            }
          }, {
            headerName: this.$t('SystemMaintenance.PushChannel'),
            width: 300,
            field: 'pushChannel',
            cellRenderer: (params) => {
              const row = this.allPushChannel.find(item => {
                return item.value === params.value
              })
              return row ? row.name : params.value
            }
          }
        ],
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: []
      },
      currFileTypeNames: '',
      // fileTreeGrid: {
      //   gridOptions: {
      //     rowSelection: 'multiple',
      //     groupDefaultExpanded: 1,
      //     suppressRowClickSelection: true,
      //     treeData: true,
      //     getDataPath: (data) => {
      //       return data.path.split(',')
      //     },
      //     autoGroupColumnDef: {
      //       headerName: this.$t('SystemMaintenance.Name'),
      //       width: 350,
      //       cellRendererParams: {
      //         suppressCount: true,
      //         suppressDoubleClickExpand: true,
      //         innerRenderer: (params) => {
      //           if (params.data.level === 0) { return params.data.chineseName }
      //           return `${params.node.childIndex}.` + params.data.chineseName
      //         },
      //         checkbox: (params) => {
      //           return params.data.type === 2
      //         }
      //       }
      //     }
      //   },
      //   rowData: [],
      //   columnDefs: []
      // },
      sopForm: {
        templateTitle: '',
        templateText: '',
        templateTitle2Email: '',
        templateText2Email: '',
        templateTitle2Note: '',
        templateText2Note: '',
        templateTheme: '',
        sendAlone: false,
        syncSendCCAddress: false
      },
      templateTitle2Email: '',
      sendSopTest: {
        visible: false,
        target: ''
      },
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: ''
      }
    }
  },
  computed: {
    emailTextQuillEditor() {
      return this.$refs.emailTextQuillEditor.quill
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    url() {
      return URL
    },
    showName() {
      if (this.dataItemTab) {
        const item = this.dataItemTabs.find(item => item.code === this.dataItemTab)
        if (!item) {
          return ''
        }
        return this.isZh ? item.chineseName : item.englishName
      }
      return ''
    },
    templateThemes() { // 模板主题
      const themes = []
      switch (this.lob) {
        case 'SE':
          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)

          break
        case 'SI':

          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)

          break
        case 'AE':
          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)
          break
        case 'AI':

          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)
          break
      }
      return themes
    },
    pushChannels() { // 推送渠道
      if (this.lob === 'SE' && this.sopForm.pushObject === 'customer') {
        return [{ name: this.$t('constant.email'), value: 0 }, { name: this.$t('constant.note'), value: 1 }, { name: this.$t('constant.enterpriseWechat'), value: 2 }]
      } else {
        return [{ name: this.$t('constant.email'), value: 0 }]
      }
    },
    pushObjects() { // 推送对象
      let pushObject = []
      switch (this.sopForm.pushChannel) {
        case 0: // email
          switch (this.lob) {
            case 'RE':
            case 'RI':
            case 'SE':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESTINATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel, this.allPushObject.SHIPPER, this.allPushObject.CONSIGNEE, this.allPushObject.NOTIFY]
              break
            case 'SI':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT3, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel, this.allPushObject.SHIPPER, this.allPushObject.CONSIGNEE, this.allPushObject.NOTIFY]
              break
            case 'AE':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESTINATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel, this.allPushObject.SHIPPER, this.allPushObject.CONSIGNEE, this.allPushObject.NOTIFY]
              break
            case 'AI':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESIGNATION_AGENT3, this.allPushObject.DesignatedPostsAndPersonnel, this.allPushObject.SHIPPER, this.allPushObject.CONSIGNEE, this.allPushObject.NOTIFY]
              break
            case 'IE':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DesignatedPostsAndPersonnel, this.allPushObject.SHIPPER, this.allPushObject.CONSIGNEE, this.allPushObject.NOTIFY]
              break
          }
          break
        case 1:
          pushObject = [this.allPushObject.CUSTOMER]
          break
        case 2:
          pushObject = [this.allPushObject.CUSTOMER]
          break
      }
      return pushObject
    },
    dataItems() {
      let allDataItems = []
      switch (this.lob) {
        case 'SE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS
          break
        case 'SI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_SI
          break
        case 'AE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_AE
          break
        case 'AI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_AI
          break
        case 'RE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_RE
          break
        case 'RI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_RI
          break
        case 'IE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_IE
          break
      }
      return allDataItems.filter(item => item.tab === this.dataItemTab)
    },
    sopDataItems() {
      return SopUtil.sopDataItems(this.lob)
    },
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readOnly() {
      return this.opStatus === 'read'
    },
    fileTreeGridRowData() {
      if (!this.fileTreeMap || !this.lob) {
        return []
      }
      return this.fileTreeMap[this.lob]
    },
    // CARGO-46447 当推送对象为 客户/指定货代理/目的港代理/发货人/收货人/通知人 时，增加勾选项【同发送抄送地址】，默认不勾选
    showSyncSendCCAddress() {
      return this.sopForm.pushObject && (
        this.sopForm.pushObject === 'customer' ||
      this.sopForm.pushObject === 'DestinationAgent' ||
      this.sopForm.pushObject === 'DesignationAgent' ||
      this.sopForm.pushObject === 'Shipper' ||
      this.sopForm.pushObject === 'Consignee' ||
      this.sopForm.pushObject === 'Notify')
    },
    // 企业微信
    isEnterpriseWechat() {
      if (this.sopForm && this.sopForm.pushChannel === 2) {
        return true
      }
      return false
    }
  },
  watch: {
    'sopForm.templateTheme': function(val) {
      this.sopForm.templateTitle = val
      if (val) {
        this.getTheme(this.sopForm, val)
      }
    },
    'templateTitle2Email': function(val) {
      this.sopForm.templateTitle = val
    },
    'sopForm.templateText2Email': function(val) {
      this.sopForm.templateText = val
    }
  },
  created() {
    // this.fileTreeGrid.gridOptions = {
    //   onRowSelected: (event) => {
    //     this.onFileTypeRowCheck(event)
    //   }, ... this.fileTreeGrid.gridOptions
    // }
  },
  destroyed() {
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener('click', this.clickOther)
    }, 100)
  },
  methods: {
    // 下拉框选中
    selectItem(item) {
      this.dataItemTab = item.code
      this.chooseId = ''
    },
    // 展开下拉框
    spread() {
      if (this.isShow) {
        this.isShow = false
      } else {
        this.isShow = true
        this.chooseId = ''
      }
    },
    onShow() {
      this.sopGrid.rowData = this.trackingDetail.trackingTemplateConfigVOList
      this.initDataItemTabs()
    },
    onEditorFocus(quill) {
      this.eFocus = this.constant.eFocus.emailContent
      this.cursor = this.emailTextQuillEditor.selection.savedRange.index
    },
    keyUp() {
      this.cursor = this.emailTextQuillEditor.selection.savedRange.index
    },
    onEditorChange(editor) {
      this.sopForm.templateText = editor.html
      this.keyUp()
    },
    // onFileTypeRowCheck(event) {
    //   const chooseRows = getGridSelected(this.fileTreeGrid.gridOptions)
    //   if (!chooseRows || chooseRows.length === 0) {
    //     this.currFileTypeNames = ''
    //     return
    //   }
    //   const smallishfileType = Array.from(chooseRows, row => { return { code: row.code, chineseName: row.chineseName } })
    //   this.currFileTypeNames = Array.from(smallishfileType, type => type.chineseName).reduce((p, l) => {
    //     return p + ',' + l
    //   })
    //   this.sopForm.fileId = Array.from(smallishfileType, type => type.code).reduce((p, l) => p + ',' + l)
    // },
    onSopReady(params) {
      setTimeout(function() {
        params.api.sizeColumnsToFit()
      })
      window.addEventListener('resize', function() {
        setTimeout(function() {
          params.api.sizeColumnsToFit()
        })
      })
    },
    onSopRowClick(event) {
      this.chooseId = ''
      this.dataItemTab = 1
      this.isShow = false
      const data = event.data
      if (data.pushChannel === 0 || data.pushChannel === 2) {
        this.templateTitle2Email = data.templateTitle
        data.templateText2Email = data.templateText
      } else {
        // note
        data.templateTheme = data.templateTitle
        // 和 watch 同步sync
        this.getTheme(data, data.templateTheme)
      }
      this.dataItem = ''
      this.sopForm = data
      this.currFileTypeNames = ''
      if (data.pushChannel === 0 || data.pushChannel === 2) {
        // this.$nextTick(() => {
        //   const api = this.fileTreeGrid.gridOptions.api
        //   if (api) {
        //     api.forEachNode((node) => {
        //       node.setSelected(data.fileId.split(',').includes(node.data.code))
        //     })
        //   }
        // })
        if (this.sopForm.fileId) {
          const codeSet = new Set(this.sopForm.fileId.toUpperCase().split(','))
          const names = []
          for (const row of this.fileTreeGridRowData) {
            if (codeSet.has(row.code.toUpperCase())) {
              names.push(row.chineseName)
            }
          }
          if (names.length > 0) {
            this.currFileTypeNames = names.join(',')
          } else {
            this.currFileTypeNames = ''
          }
        }
      }
    },
    onClickSopDataItem(index) { // 点击sop数据项的button
      const btnContent = this.sopDataItems[Number(index)]
      this.onClickSopDataItemByContent(btnContent, index)
    },
    changeDataItem(p) {
      if (!p.value) {
        this.dataItem = ''
        return
      }
      this.dataItem = p.value
      this.onClickSopDataItemByContent(p.value)
    },
    blurEvent(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    onClickSopDataItemByContent(btnContent, index) {
      const cursor = this.cursor // 正文光标位置
      const blurIndex = this.blurIndex // 主题模板光标位置
      const str = this.templateTitle2Email
      this.chooseId = index
      if (this.eFocus === this.constant.eFocus.emailTitle) {
        this.templateTitle2Email = str.slice(0, blurIndex) + `\$\{${btnContent}\}` + str.slice(blurIndex)
        this.$refs['themeTemplate'].focus()
      } else if (this.eFocus === this.constant.eFocus.emailContent) {
        this.emailTextQuillEditor.insertEmbed(cursor, 'text', `\$\{${btnContent}}`)
        this.emailTextQuillEditor.setSelection(cursor + 3 + btnContent.length)
        this.$nextTick(function() {
          this.emailTextQuillEditor.blur()
        })
      } else {
        this.$refs['emailTextQuillEditor'].focus()
        this.eFocus = this.constant.eFocus.emailContent
      }
    },
    // 新增
    addSop() {
      const data = {
        uuid: '',
        pushChannel: 0,
        pushObject: 'customer',
        lob: this.lob,
        templateTitle: '',
        templateText: '',
        templateTitle2Email: '',
        templateText2Email: '',
        templateTitle2Note: '',
        templateText2Note: '',
        templateTheme: '', // 短信模板主题
        fileId: '', // 附件类型
        trackingDetailUuid: this.trackingDetail.uuid,
        pushNode: '', // trackingDetail.codeCname 推送节点
        mailServerType: 0,
        sendEmail: 0,
        position: '',
        assigner: 0,
        valueChangePushMsg: false,
        checkBase: false
      }
      this.sopGrid.rowData.push(data)// 默认选中第一行
      this.sopGrid.gridOptions.api.setFocusedCell(1, this.sopGrid.gridOptions.api.columnController.getAllDisplayedColumns()[this.sopGrid.rowData.length - 1])
      this.onSopRowClick({ data: data })
    },
    async delSop() {
      const cell = this.sopGrid.gridOptions.api.getFocusedCell()
      const nodes = this.sopGrid.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseFirstSelectData'))
        return
      }
      await this.$confirm(this.$t('SystemMaintenance.AreToDeleteTheRecord'), this.$t('SystemMaintenance.Prompt'), { type: 'waring' })
      if (node.data.uuid) {
        if (!this.trackingDetail.delConfigKeys) {
          this.trackingDetail.delConfigKeys = []
        }
        this.trackingDetail.delConfigKeys.push(node.data.uuid)
      }
      const index = this.sopGrid.rowData.findIndex(p => p === node.data)
      if (index >= 0) {
        this.sopGrid.rowData.splice(index, 1)
      }
      // 移除表格数据
      this.sopGrid.gridOptions.api.updateRowData({ 'remove': [node.data] })
      this.sopForm = {
        templateTitle: '',
        templateText: '',
        templateTitle2Email: '',
        templateText2Email: '',
        templateTitle2Note: '',
        templateText2Note: '',
        templateTheme: '' // 短信模板主题
      }
      this.dataItem = ''
    },
    getTheme(data, val) {
      getTemplateTheme(val).then(res => {
        data.templateTitle2Note = res.data.logRichNoteEditor
        data.templateText2Note = res.data.richNoteEditor
      })
    },
    showSendSopTest() { // 发送测试
      if (this.isEnterpriseWechat) {
        return
      }
      this.sendSopTest.visible = true
    },
    sendSopTestHandler() {
      const text = this.sendSopTest.target
      // 是否测试邮箱
      const ifEmail = this.sopForm.pushChannel === 0
      if (ifEmail) {
        if (!text) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseTheTestEmailAddress'))
          return
        }
        if (text && text.indexOf('@') === -1) {
          this.$message.warning(this.$t('SystemMaintenance.EmailFormatError'))
          return
        }
        if (text && text.length > 128) {
          this.$message.warning(this.$t('SystemMaintenance.EmailCannotExceed128Characters'))
          return
        }
        const params = {}
        params.key = text
        params.templateConfig = this.getTrackingTemplateData()
        const loading = getLoading()
        TrackingTemplateConfigApi.sendTestEmail(params).then(resp => {
          this.testSuccessHandler(resp)
        }).finally(() => loading.close())
      } else {
        if (!text) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseEnterTestMobileNumber'))
          return
        }
        const regex = /^[0-9]*$/
        if (text && !regex.test(text)) {
          this.$message.warning(this.$t('SystemMaintenance.MobileOnlyBeANumber'))
          return
        }
        if (text && text.length !== 11) {
          this.$message.warning(this.$t('SystemMaintenance.MobileNumberFormatError'))
          return
        }
        const params = {}
        params.key = text
        params.templateConfig = this.getTrackingTemplateData()
        const loading = getLoading()
        TrackingTemplateConfigApi.sendTestNote(params).then(resp => {
          this.testSuccessHandler(resp)
        }).finally(() => loading.close())
      }
    },
    /**
     * 封装数据
     * @return
     */
    getTrackingTemplateData() {
      const t = {}
      t.lob = this.lob
      t.pushObject = this.sopForm.pushObject
      t.pushChannel = this.sopForm.pushChannel
      if (this.sopForm.pushChannel === 0 || this.sopForm.pushChannel === 2) {
        t.templateTitle = this.templateTitle2Email
        t.templateText = this.sopForm.templateText2Email
      } else if (this.sopForm.pushChannel === 1) {
        t.templateTitle = this.sopForm.templateTheme
        t.templateText = this.sopForm.templateTitle2Note
      }
      if (this.sopForm.fileId) {
        t.fileId = this.sopForm.fileId
      }
      t.trackingDetailUuid = this.trackingDetail.uuid
      t.pushNode = this.trackingDetail.codeCname
      return t
    },
    testSuccessHandler(resp) {
      const result = resp.data
      if (result > 0) {
        this.$message.success(this.$t('SystemMaintenance.SendingSuccessful'))
      } else {
        this.$message.error(this.$t('SystemMaintenance.SendingFailed'))
      }
      this.sendSopTest.visible = false
    },
    sendSopTestCloseHandler() {
      this.sendSopTest.visible = false
      this.sendSopTest.target = ''
    },
    refreshGrid() {
      if (this.sopForm.pushObject !== 'customer') {
        this.sopForm.checkBase = false
      }
      this.sopGrid.gridOptions.api.refreshCells({ force: true })
    },
    initDataItemTabs() {
      const allTabs = [...SopDataItemTabConstants.SOP_DATA_ITEM_TABS, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_IE, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_RI,
        ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_RE, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_AI, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_AE,
        ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_SI]
      const tabs = allTabs.filter(item => item.lob === this.lob)
      if (tabs && tabs.length > 0) {
        this.dataItemTab = tabs[0].code
      }
      this.dataItemTabs = tabs
    },
    showFileTypeDialog() {
      this.fileTypeEditor.fileCategory = this.sopForm.fileId
      this.fileTypeEditor.visible = true
    },
    onSaveFileType(data) {
      this.sopForm.fileId = data.fileCategory
      this.currFileTypeNames = data.fileCategoryLabel
    },
    onMailServerTypeInput(val) {
      this.sopForm.mailServerType = val || 0
      if (this.sopForm.mailServerType !== 3) {
        this.sopForm.sendEmail = 0
        this.sopForm.position = ''
        this.sopForm.assigner = 0
      }
    },
    onSendEmailChange(val) {
      if (val === 1) {
        this.sopForm.position = 'sales'
        this.sopForm.assigner = 0
      } else {
        this.sopForm.position = ''
        this.sopForm.assigner = 0
      }
    },
    clickOther(e) {
      if (e && this.isShow && this.$refs.dataItemTabDiv && !this.$refs.dataItemTabDiv.contains(e.target)) {
        this.isShow = false
      }
    },
    dataItemFocusEvent() {
      if (this.isShow) {
        this.isShow = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .sop-message-setting-form{
    .el-form-item{
      margin-top: 10px;
    }
    .outside{
      width: 100px;
      height:28px;
      border-radius:2px;
      border: 1px solid #ccc;
      position:relative;
      margin-right: 10px;
      .mask{
        display:inline-block;
        width:100px;
        height:28px;
        border-radius:2px;
        background-color: #ccc;
        opacity: 0.3;
        position:absolute;
        left:0;
        top:0;
      }
      .outside-value{
        height: 30px;
        padding-left: 5px;
        cursor:pointer;
      }
      .operation{
        z-index:999;
        position:absolute;
        left:0;
        top:35px;
        display: flex;
        flex-direction: column;
        width:150px;
        height: 160px;
        overflow-y: auto;
        border: 1px solid #ccc;
        background-color: #fff;
        border-radius:2px;
        .item{
          cursor: pointer;
          line-height: 30px;
          padding:0 5px;
          margin:2px 0;
          box-sizing:border-box;
          &:hover{
            color:#000000;
            background-color: #C3CCE7;
          }
        }
      }
      .dataItem{
        display: flex;
        justify-content: start;
        position:absolute;
        z-index: 9999;
        flex-wrap: wrap;
        height: 110px;
        width: 430px;
        background: #fff;
        right: -440px;
        top:35px;
        border: 1px solid #ccc;
        overflow-y: scroll;
        padding: 5px;
        box-sizing: border-box;
        left: 160%;
        .item{
          padding: 0 10px;
          min-width:50px;
          height:30px;
          text-align: center;
          line-height: 30px;
          color: #000000;
          border-radius: 3px;
          border: 1px solid #cccccc;
          font-size: 12px;
          display: inline-block;
          margin:0 5px 5px 0;
          cursor: pointer;
          &:hover{
            background: #FFFFFF;
            border-color: #1F75D5;
            color: #1F75D5;
          }
        }
        .itemChoose{
          color: #FFFFFF;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:hover{
            color: #FFFFFF;
            background-color: #1F75D5;
            border-color: #1F75D5;
          }
        }
      }
      .set-color{
        color:#000000;
        background-color: #C3CCE7;
      }
      .icon{
        position: absolute;
        right: 5px;
        top: 27%;
        transform: translateY(-60%);
        pointer-events: none;
      cursor: pointer;
      }
      .rotatingShow{
        transform: rotate(180deg);
        transition: all 0.2s ease 0s;
      }
      .rotatingHide{
        transform: rotate(0deg);
        transition: all 0.2s ease 0s;
      }
    }
  }
</style>
